import { type DistanceUnit, distanceUnits } from "@/models/siteUnit.types";
import { createDistanceUnitPort } from "@/models/units/distanceUnitPort";
import { fetchObjectDxfBlob } from "@/utils/dxfExportApi";

interface IGeometryLike {
	vertices: number[];
	indices: number[];
}

/**
 * TIN を DXF 文字列にする。生成は v2-server `POST /:siteId/object/dxf` (Python ezdxf、R2007)
 * に委ねる。道路・平場の DXF Export と同じ経路で、Trend-Point 等の土工ツールが読める
 * R2000〜R2007 の完全な構造 (TABLES / ハンドル / OBJECTS) を client で手書きしないため。
 * 座標は現場距離単位へ換算して送り、`distanceUnit` が `$INSUNITS` になる。
 * @param name DXF 内の名前 (server 側でファイル名にサニタイズされる)。レイヤは `spreading`
 * @param siteId v2-server の DXF 生成は site スコープなので必須
 */
export async function buildDxfString(
	geometry: IGeometryLike,
	name: string,
	siteId: string,
	distanceUnit: DistanceUnit = distanceUnits.METERS,
): Promise<string> {
	const port = createDistanceUnitPort(distanceUnit);
	const blob = await fetchObjectDxfBlob({
		siteId,
		name,
		objectType: "spreading",
		vertices: geometry.vertices.map((v) => port.toDisplay(v)),
		indices: geometry.indices,
		distanceUnit,
	});
	return blob.text();
}
